<template>
  <form v-on:submit.prevent="onSubmit">
    <div class="modal-header">
      <h4 class="modal-title">Add Procurement Type</h4>
    </div>

    <div class="modal-body">
      <div class="form-group">
        <label for="procurementTypeName">Name <span class="red-dot ml-3"></span></label>
        <input id="procurementTypeName" name="procurementTypeName" type="text" class="form-control" :class="{ 'is-invalid': errors.has('procurementTypeName') }"
          autocomplete="off" placeholder="Name" v-model="procurementType.name" v-validate="'required'" data-vv-as="Name" />
        <div class="invalid-feedback">The Name field is required.</div>
      </div>

      <div class="form-group">
        <label for="procurementTypeSortOrder">Sort Order <span class="red-dot ml-3"></span></label>
        <input id="procurementTypeSortOrder" name="procurementTypeSortOrder" type="text" class="form-control" :class="{ 'is-invalid': errors.has('procurementTypeSortOrder') }"
          autocomplete="off" placeholder="Sort Order" v-model="procurementType.sortOrder" v-validate="'required'" data-vv-as="Sort Order" />
        <div class="invalid-feedback">The Sort Order field is required.</div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="submit" class="btn btn-success">Save</button>
      <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
    </div>
  </form>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Toast from "@/utils/toast";

export default {
  name: 'contact-type',
  data: function () {
    return {
      isEdit: false,
      procurementType: {}
    }
  },
  computed: {
    ...mapGetters(["getProcurementType"])
  },
  mounted: function() {
    this.procurementType = { ...this.getProcurementType };
    this.isEdit = !!this.procurementType.id;
    this.$validator.reset();
  },
  methods: {
    async onSubmit() {
      var isFormValid = await this.$validator.validate();

      if (!isFormValid) {
        return;
      }

      this.saveProcurementType({ data: this.procurementType, isEdit: this.isEdit })
        .then(() => {
          Toast.success(this, "Successfully saved!");
          this.$bvModal.hide("bv-modal-procurement-type");
          this.closeModal();
        })
        .catch(() => {
          Toast.danger(this, "Oops! There was an error.");
          this.closeModal();
        });
    },
    closeModal() {
      this.$bvModal.hide("bv-modal-procurement-type");
    },
    ...mapActions(["saveProcurementType"])
  }
}
</script>
